var render = function render(){var _vm=this,_c=_vm._self._c;return _c('administration-layout',[_c('div',{staticClass:"flex flex-col items-center py-4"},[_c('business-form',{on:{"onMyBusinessFormSave":_vm.onSave}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }